import { render } from "./EducationFee.vue?vue&type=template&id=43c2a0b0"
import script from "./EducationFee.vue?vue&type=script&lang=js"
export * from "./EducationFee.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__